import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import Utils from "../utils/Utils";
import i18n from "../i18n";

const { serverURL } = Utils;

const initialState = {
  status: "idle",
  subscription: null,
  error: null,
};

export const subscribePush = createAsyncThunk(
  "pushSubscription/subscribePush",
  async (subscriptionData) => {
    const response = await fetch(`${serverURL}/push/subscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(subscriptionData),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  }
);

export const unsubscribePush = createAsyncThunk(
  "pushSubscription/unsubscribePush",
  async (arg) => {
    const { endpoint } =
      typeof arg === "string" ? { endpoint: arg } : arg || {};
    const response = await fetch(`${serverURL}/push/unsubscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ endpoint }),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  }
);

const pushSubscriptionSlice = createSlice({
  name: "pushSubscription",
  initialState,
  reducers: {
    clearPushError: (state) => {
      state.error = null;
    },
    clearPushSubscription: (state) => {
      state.subscription = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribePush.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(subscribePush.fulfilled, (state, action) => {
        state.status = "success";
        state.subscription = action.payload;
        state.error = null;
        toast.success(i18n.t("pushNotificationsEnabled"));
      })
      .addCase(subscribePush.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        toast.error(i18n.t("pushEnableFailed", { message: action.error.message }));
      })
      .addCase(unsubscribePush.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(unsubscribePush.fulfilled, (state, action) => {
        state.status = "success";
        state.subscription = null;
        state.error = null;
        if (!action.meta.arg?.silent) {
          toast.success(i18n.t("pushNotificationsDisabled"));
        }
      })
      .addCase(unsubscribePush.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        if (!action.meta.arg?.silent) {
          toast.error(
            i18n.t("pushDisableFailed", { message: action.error.message })
          );
        }
      });
  },
});

export const { clearPushError, clearPushSubscription } = pushSubscriptionSlice.actions;
export default pushSubscriptionSlice.reducer;